module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/partner1-b32409a62885ccd770191fd7a2b30c83.png";